var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAscDec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.51345 8.7619V0.952381C4.51345 0.68254 4.608 0.456349 4.79709 0.27381C4.98617 0.0912698 5.22048 0 5.5 0C5.77952 0 6.01383 0.0912698 6.20291 0.27381C6.392 0.456349 6.48655 0.68254 6.48655 0.952381V8.7619L9.34753 6C9.5284 5.8254 9.7586 5.7381 10.0381 5.7381C10.3176 5.7381 10.5478 5.8254 10.7287 6C10.9096 6.1746 11 6.39683 11 6.66667C11 6.93651 10.9096 7.15873 10.7287 7.33333L6.19058 11.7143C5.99327 11.9048 5.76308 12 5.5 12C5.23692 12 5.00673 11.9048 4.80942 11.7143L0.2713 7.33333C0.0904335 7.15873 0 6.93651 0 6.66667C0 6.39683 0.0904335 6.1746 0.2713 6C0.452167 5.8254 0.682362 5.7381 0.961883 5.7381C1.24141 5.7381 1.4716 5.8254 1.65247 6L4.51345 8.7619Z",
    fill: "#747474"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscDec);
export default __webpack_public_path__ + "static/media/asc-dec.a81b3beb0ded25ea13fa03eefd8f0547.svg";
export { ForwardRef as ReactComponent };